import { render, staticRenderFns } from "./UserStreamsView.vue?vue&type=template&id=61f2e970&scoped=true&"
import script from "./UserStreamsView.vue?vue&type=script&lang=ts&"
export * from "./UserStreamsView.vue?vue&type=script&lang=ts&"
import style0 from "./UserStreamsView.vue?vue&type=style&index=0&id=61f2e970&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f2e970",
  null
  
)

export default component.exports